import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Jednovýberový dropdown pre "Typ priečinka" — vizuálne zhodný s ostatnými
// (Tímy, Prístupové oprávnenia): rovnaké triedy .mill-multiselect / .dropdown-menu.
export default function EnvTypeSelect({ value, onChange, name = 'type' }) {

    const [t] = useTranslation('global');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const options = [
        { value: 'M', label: t('typeManual') || 'Manual' },
        { value: 'S', label: t('typeSharePoint') || 'SharePoint' },
        { value: 'N', label: t('typeNetworkDrive') || 'Zdieľaný disk' },
    ];
    const selected = options.find((o) => o.value === value) || options[0];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const pick = (v) => {
        onChange({ target: { name, value: v } });
        setIsDropdownOpen(false);
    };

    return (
        <div className="mill-multiselect" ref={dropdownRef}>
            <label>{t('environmentType') || 'Typ priečinka'}</label>
            <div className="multiselect-line" onClick={() => setIsDropdownOpen((o) => !o)}>
                <div className="selected-values">
                    <span className="single-select-value">{selected.label}</span>
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isDropdownOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isDropdownOpen && (
                <div className="dropdown-menu">
                    <ul className="dropdown-list">
                        {options.map((option) => (
                            <li
                                key={option.value}
                                className={`dropdown-item ${option.value === value ? "selected" : ""}`}
                                onClick={() => pick(option.value)}
                            >
                                {option.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
